import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'petitionGuidesArticle',
		path: '/petition-guides/:slug',
		component: loadable(async () => import(/* webpackChunkName: "pages/PetitionGuidesArticle" */ './index'), {
			exportName: 'PetitionGuidesArticle',
			fallback: Loading,
		}),
		frame: true,
		ssr: {
			enabled: true,
			seo: true,
		},
	},
];
